module.exports = __webpack_public_path__ + "img/person1@2x.d7dbe6ec.png";